<template>
  <div class="share-route">
    <div class="top-title-bg">
      <img src="../../assets/images/title_dkgdhsdt.png" />
    </div>
    <div class="route-img">
      <img :src="posterDetail.posterUrl" />
    </div>
    <div class="center-line">
      <img class="img-line" src="../../assets/images/line_star_l.png" />
      <div class="text">红色路线</div>
      <img class="img-line" src="../../assets/images/line_star_r.png" />
    </div>
    <div class="list-content">
      <div class="card-item" v-for="item in listContent" :key="item.id" @click="goToShopDetailPage(item)">
        <img :src="item.mainImage" />
        <div class="card-right">
          <div class="right-title">{{ item.titleName }}</div>
          <div class="right-tag-distance-address">
            <div class="tag" v-if="item.tagName">{{ item.tagName }}</div>
            <div class="distance">{{ item.distance }}km</div>
            <div class="line">|</div>
            <div class="distance">{{ item.address.city }}</div>
          </div>
          <!-- <div class="open-time">开放时间：{{ item.openingHours }}</div> -->
        </div>
      </div>
    </div>
    <div @click="handleGoIndex" class="bottom-btn">查看更多红色遗址</div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getRedRouteDetailByIdScan } from '@/server/interfaces'
import { getDistance } from '@/utils/amap'
export default {
  name: '',
  data() {
    return {
      listContent: [],
      routeId: '',
      activityId: '',
      userPosition: null,
      defaultPosition: {
        latitude: 23.137,
        longitude: 113.325,
        valid: true,
      },
      posterDetail: {},
      map: null,
    }
  },
  computed: {},
  async mounted() {
    this.routeId = this.$route.query.routeId
    this.activityId = this.$route.query.id
    try {
      this.showLoading()
      if (this.userPosition) {
        await this.getDataDetail()
      } else {
        this.getUserPosition()
      }
    } catch (e) {
      window.console.error(e)
    }
  },
  methods: {
    ...mapMutations({
      toast: 'toast/showToast',
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
    }),
    /**获取用户的位置信息 */
    getUserPosition() {
      /* global AMap */
      this.map = new AMap.Map('map-container-fake', {
        center: [113.325, 23.137],
      })
      this.map.plugin('AMap.Geolocation', () => {
        const geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 10000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: false, // 显示定位按钮，默认：true
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })
        this.map.addControl(geolocation)
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', this.onComplete) // 返回定位信息
        AMap.event.addListener(geolocation, 'error', this.onError) // 返回定位出错信息
      })
    },
    /**用户地理位置赋值 */
    onComplete(obj) {
      this.userPosition = {
        latitude: obj.position.lat,
        longitude: obj.position.lng,
        valid: true,
      }
      this.getDataDetail()
    },
    /**获取不到定位，默认用这个定位 */
    onError(obj) {
      this.userPosition = this.defaultPosition
      this.getDataDetail()
    },
    /**获取用户距离遗址的距离 */
    getInfoDistance(pointX, pointY) {
      console.log('userPosition', this.userPosition)
      if (!this.userPosition) return
      return getDistance({ lng: pointX, lat: pointY }, { lng: this.userPosition?.longitude, lat: this.userPosition?.latitude })
    },
    /**获取路线数据 */
    async getDataDetail() {
      try {
        if (!this.routeId) {
          this.hideLoading()
          return
        }
        const params = {
          id: this.routeId,
        }
        const result = await getRedRouteDetailByIdScan({ params })
        this.posterDetail = {
          ...result,
          posterUrl: result.poster?.url,
        }
        this.listContent = result.stores
        this.listContent.forEach((item) => {
          const point = item?.address?.point
          item.distance = this.getInfoDistance(point.x, point.y)
          item.titleName = item.name
          item.tagName = item?.redTemplate?.topCategory?.name
          item.openingHours = item?.redTemplate?.openingHours
        })
        this.hideLoading()
      } catch (error) {
        console.error(error)
      }
    },
    handleGoIndex() {
      this.$router.replace({
        path: '/',
        query: { id: this.activityId },
      })
    },
    goToShopDetailPage(item) {
      this.$router.push({
        path: '/detailPage',
        query: {
          shopId: item.id,
          id: this.activityId,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.share-route {
  background-color: #ac1414;
  padding: 0.74rem 0 0.6rem;
  box-sizing: border-box;
  .top-title-bg {
    width: 100%;
    height: 1.89rem;
    position: absolute;
    top: 0;
    left: 0;
    & > img {
      width: 100%;
      height: 1.98rem;
    }
  }
  .route-img {
    height: 6.88rem;
    width: calc(100% - 0.4rem);
    margin: 0 auto;
    // padding-top: 0.74rem;
    background-image: url('../../assets/images/card_dkgdhsdt.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    // position: relative;
    display: flex;
    justify-items: center;
    align-items: center;
    & > img {
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%,-50%);
      width: calc(100% - 0.3rem);
      margin: 0 auto;
      display: block;
      //   height: 100%;
    }
  }
  .center-line {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.2rem 0;
    .text {
      width: 1.24rem;
      // height: 0.37rem;
      // line-height: 0.37rem;
      text-align: center;
      font-size: 0.26rem;
      color: #ffdab4;
      font-weight: 400;
      margin: 0 0.1rem;
    }
    .img-line {
      width: calc(50% - 1.34rem);
    }
  }
  .list-content {
    width: calc(100% - 0.4rem);
    margin: 0 auto;
    background: #fff;
    box-shadow: 0 -0.04rem 0.08rem 0 #716c6233;
    border-radius: 0.14rem;
    margin-bottom: 0.4rem;
    padding: 0.2rem 0;
    .card-item {
      display: flex;
      padding: 0.2rem 0.3rem;
      & > img {
        width: 1.8rem;
        height: 1.8rem;
        border-radius: 0.14rem;
        margin-right: 0.2rem;
      }
      .card-right {
        flex: 1;
        .right-title {
          // height: 0.88rem;
          font-size: 0.34rem;
          color: #333;
          font-weight: 600;
          margin-bottom: 0.2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .right-tag-distance-address {
          display: flex;
          align-items: center;
          margin-bottom: 0.04rem;
          .tag {
            height: 0.4rem;
            padding: 0 0.1rem;
            line-height: 0.4rem;
            background: #ffdaa2;
            border-radius: 0.08rem;
            font-size: 0.22rem;
            color: #a54400;
            margin-right: 0.1rem;
          }
          .distance {
            font-size: 0.26rem;
            color: #666;
            font-weight: 400;
          }
          .line {
            padding: 0 0.2rem;
            font-size: 0.26rem;
            color: #ccc;
            font-weight: 400;
          }
          .address {
            font-size: 0.26rem;
            color: #666;
            font-weight: 400;
          }
        }
        .open-time {
          font-size: 0.26rem;
          color: #666;
          font-weight: 400;
        }
      }
    }
  }
  .bottom-btn {
    width: 3.2rem;
    text-align: center;
    height: 0.75rem;
    line-height: 0.75rem;
    border-radius: 0.38rem;
    background-image: linear-gradient(180deg, #ff9f00 0%, #ff601a 100%);
    border-radius: 0.38rem;
    font-size: 0.3rem;
    color: #fff;
    font-weight: 400;
    margin: 0 auto;
  }
}
</style>